import React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import UserMenu from '../../elements/user-menu.element';

interface AdminTopBarProps {
  onToggle?: () => void;
}

const AdminTopBar: React.FC<AdminTopBarProps> = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar>
        {/* <IconButton onClick={onToggle}>
          <MenuIcon />
        </IconButton> */}
        <Typography variant="h6" sx={{ flex: 1 }}>
          &nbsp;
        </Typography>
        {isAuthenticated && <UserMenu />}
      </Toolbar>
    </AppBar>
  );
};

export default AdminTopBar;
